import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

// Componentes Globales
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsentComponent from './components/CookieConsent';
import ProtectedRoute from './components/ProtectedRoute';

// Páginas Públicas
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import QualityPolicyPage from './pages/QualityPolicyPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';

// Páginas de Administración (CMS)
import AdminLoginPage from './pages/AdminLoginPage';
import AdminUsersPanel from './pages/AdminUsersPanel';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background text-foreground flex flex-col font-sans">
        <Toaster position="top-right" richColors />
        
        {/* Renderizamos el componente CookieConsent */}
        <CookieConsentComponent />

        <Header />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/quality-policy" element={<QualityPolicyPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />

            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            <Route 
              path="/admin/users" 
              element={
                <ProtectedRoute>
                  <AdminUsersPanel />
                </ProtectedRoute>
              } 
            />

            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;